// @ts-nocheck


import { fetchRequest } from './index';


export const fetchOsagoCalculationYear = async (year) =>
await fetchRequest.get(`/osagoCalculationYear/${year}/byYear`);

export const changeOsagoCalculationStatusYear = async (
osagoCalculationYear) =>

await fetchRequest.post(
  `/osagoCalculationYear/changeStatus`,
  osagoCalculationYear
);

export const getOsagoCalculationYear = async (id) =>
await fetchRequest.get(`/osagoCalculationYear/${id}`);

export const deleteOsagoCalculationYear = async (id) =>
await fetchRequest.delete(`/osagoCalculationYear/${id}`);

export const addOsagoCalculationYear = async (
osagoCalculationYear) =>
{
  const added = await fetchRequest.post(
    '/osagoCalculationYear',
    osagoCalculationYear
  );
  if (added) return added;
  throw new Error('Не удалось создать расчет стоимости ОСАГО');
};

export const recalculationOsagoCalculationYear = async (data) =>


{
  const added = await fetchRequest.put(
    '/osagoCalculationYear/recalculation',
    data
  );
  if (added) return added;
  throw new Error('Не удалось пересчитать расчет стоимости ОСАГО');
};

export default {
  addOsagoCalculationYear,
  getOsagoCalculationYear,
  fetchOsagoCalculationYear,
  deleteOsagoCalculationYear,
  changeOsagoCalculationStatusYear,
  recalculationOsagoCalculationYear
};
